import type { AxiosInstance } from 'axios'

export const archiveProduct = (api: AxiosInstance) => (
  productId: string
): Promise<void> => api.delete(`/v1.0/admin/products/${productId}`)
